import * as React from "react";
import type { UserProfile, UserSettings } from "@lupp/shared";

function userInitials(user: UserProfile): string {
  const parts = user.name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return user.name.slice(0, 2).toUpperCase();
}

export interface UserProfilePanelProps {
  user: UserProfile;
  settings: UserSettings | null;
  open: boolean;
  onClose: () => void;
}

export default function UserProfilePanel({ user, settings, open, onClose }: UserProfilePanelProps): JSX.Element | null {
  if (!open) return null;

  return (
    <div className="user-profile-panel" role="dialog" aria-label="Benutzerprofil">
      <div className="user-profile-panel__header">
        <span className="user-profile-panel__title">Profil</span>
        <button
          className="icon-btn"
          type="button"
          aria-label="Schließen"
          onClick={onClose}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="user-profile-panel__avatar-row">
        {user.profileImageUrl ? (
          <img
            className="user-profile-panel__avatar-img"
            src={user.profileImageUrl}
            alt="Profilbild"
          />
        ) : (
          <div className="user-profile-panel__avatar-initials" aria-hidden="true">
            {userInitials(user)}
          </div>
        )}
        <div className="user-profile-panel__identity">
          <span className="user-profile-panel__name">{user.name}</span>
          <span className="user-profile-panel__email">{user.email}</span>
          <span className="user-profile-panel__role">{user.role}</span>
        </div>
      </div>

      {settings?.ui && (
        <div className="user-profile-panel__settings">
          {settings.ui.defaultModel !== undefined && (
            <div className="user-profile-panel__setting">
              <span className="user-profile-panel__setting-label">Standardmodell</span>
              <span className="user-profile-panel__setting-value">{String(settings.ui.defaultModel)}</span>
            </div>
          )}
          {settings.ui.defaultLanguage !== undefined && (
            <div className="user-profile-panel__setting">
              <span className="user-profile-panel__setting-label">Sprache</span>
              <span className="user-profile-panel__setting-value">{String(settings.ui.defaultLanguage)}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
